import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';

import { RouterService } from '@services/router.service';

@Component({
    template: `
        @if (code && id) {
            <div class="p-10">
                @if (code === 403 && detail) {
                    <div class="text-md text-semi mb-2">{{ detail }}</div>
                    <div class="text-md text-light">
                        To regain access, please reach out to your
                        organization’s account admin.
                    </div>
                } @else {
                    <div>
                        <div class="text-display-xl ">
                            Oops! {{ code }}{{ detail }}
                        </div>
                    </div>
                    <div class="color-gray15 mt-4">
                        <span class="text-semi">Issue Track ID: </span>
                        <span
                            tabindex="0"
                            class="cursor-pointer"
                            (click)="copy()"
                            (keyup.enter)="copy()">
                            {{ id }}
                            <mat-icon svgIcon="copy" />
                        </span>
                    </div>
                }
            </div>
        }
    `,
    imports: [MatIconModule],
})
export class ErrorPageComponent {
    code: number | null = null;
    id: string = '';
    detail: string = '';

    private readonly clipboard = inject(Clipboard);
    private readonly router = inject(Router);
    private readonly routerService = inject(RouterService);

    constructor() {
        if (this.routerService.errorRedirection) {
            this.routerService.errorRedirection = false;

            this.router.events.subscribe({
                next: (event) => {
                    if (event instanceof NavigationEnd) {
                        const navigation = this.router.getCurrentNavigation();
                        const state = navigation?.extras?.state;
                        if (state) {
                            this.code = state['code'];
                            this.id = state['id'];
                            this.detail = state['detail'];
                        }
                    }
                },
            });
        } else {
            this.routerService.goApp();
        }
    }

    copy() {
        this.clipboard.copy(this.id);
    }
}
